import { useMutation } from '@tanstack/react-query';
import { forceSyncSpreadsheetIntegration } from 'admin/resources';

interface ForceSyncInput {
	integrationId: string;
	spreadsheetId: string;
}

type ForceSyncOutput = {};

const forceSync = async (props: ForceSyncInput): Promise<ForceSyncOutput> => {
	const response = await forceSyncSpreadsheetIntegration
		.params({ id: props.integrationId, spreadsheetId: props.spreadsheetId })
		.send<ApiV2Response<ForceSyncOutput>>();

	return response.body!;
};

export const useForceSync = () => {
	return useMutation<ForceSyncOutput, ApiV2ResponseError, ForceSyncInput>({
		mutationFn: forceSync,
	});
};
